import script from "./AdminFormElementText.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminFormElementText.vue?vue&type=script&setup=true&lang=js"

import "./AdminFormElementText.vue?vue&type=style&index=0&id=5f334892&lang=scss"

const __exports__ = script;

export default __exports__